const Wishlist = (() => {
  const STORAGE_KEY = 'mb_wishlist';
  const debug = false;

  function getWishlistItems() {
    const items = localStorage.getItem(STORAGE_KEY);
    return items ? JSON.parse(items) : [];
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function addToWishlist(product) {
    const wishlist = getWishlistItems();
    const exists = wishlist.find((item) => item.id === product.id);
    if (!exists) {
      wishlist.push(product);
      saveWishlist(wishlist);
      if (debug) console.log(`Added to wishlist: ${product.title}`);
    }
  }

  function removeFromWishlist(productId) {
    let wishlist = getWishlistItems();
    wishlist = wishlist.filter((item) => item.id !== productId);
    saveWishlist(wishlist);
    if (debug) console.log(`Removed from wishlist: ${productId}`);
  }

  function isInWishlist(productId) {
    const wishlist = getWishlistItems();
    return wishlist.some((item) => item.id === productId);
  }

  function toggleWishlist(product) {
    const productId = product.id;
    if (debug) console.log('Toggling wishlist for product:', product.id);
    if (isInWishlist(productId)) {
      removeFromWishlist(productId);
      return false;
    } else {
      addToWishlist(product);
      return true;
    }
  }

  function countWishlistItems() {
    const wishlist = getWishlistItems();
    return wishlist.length;
  }

  function clearWishlist() {
    localStorage.removeItem(STORAGE_KEY);
  }

  function renderWishlist(containerSelector, emptySelector, loadingSelector) {
    if (debug) console.log('Rendering wishlist ...');
    const container = document.querySelector(containerSelector);
    const empty = document.querySelector(emptySelector);
    const loading = document.querySelector(loadingSelector);
    const items = getWishlistItems();
    container.innerHTML = '';

    if (items.length === 0) {
      empty.classList.add('active');
      loading.classList.add('hidden');
      return;
    }

    Promise.all(
      items.map((item) =>
        fetch(`/products/${item.handle}?section_id=product-card`)
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const section = doc.querySelector('#shopify-section-product-card');
            return section ? section.innerHTML : '';
          })
      )
    ).then((productCards) => {
      container.innerHTML = productCards.join('');
      this.setWishlistListener();
      setTimeout(() => {
        container.classList.add('active');
        loading.classList.add('hidden');
      }, 500);
    });
  }

  function setWishlistListener() {
    const countElement = document.getElementById('wishlist-count');
    if (countElement) {
      countElement.textContent = `[${Wishlist.countWishlistItems()}]`;
    }

    document.querySelectorAll('.add-to-wishlist-btn').forEach((button) => {
      const productId = button.dataset.productId;

      if (Wishlist.isInWishlist(productId)) {
        button.classList.add('whislist-btn-active');
      }

      if (!button.classList.contains('processed')) {
        button.classList.add('processed');
        button.addEventListener('click', () => {
          const product = {
            id: button.dataset.productId,
            title: button.dataset.productTitle,
            handle: button.dataset.productHandle,
            image: button.dataset.productImage,
          };
          Wishlist.toggleWishlist(product);
          countElement.textContent = `[${Wishlist.countWishlistItems()}]`;
          button.classList.toggle('whislist-btn-active');

          document.querySelectorAll('.add-to-wishlist-btn').forEach((trigger) => {
            if (Wishlist.isInWishlist(trigger.dataset.productId)) {
              trigger.classList.add('whislist-btn-active');
            } else {
              trigger.classList.remove('whislist-btn-active');
            }
          });
        });
      }
    });
  }

  return {
    addToWishlist,
    removeFromWishlist,
    isInWishlist,
    getWishlistItems,
    clearWishlist,
    renderWishlist,
    toggleWishlist,
    countWishlistItems,
    setWishlistListener,
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  Wishlist.setWishlistListener();
});
